import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item3/subitm1.jpg";
import img2 from "../assets/images/item3/subitm2.jpg";
import img3 from "../assets/images/item3/subitm3.jpg";
import img4 from "../assets/images/item3/subitm4.jpg";
import img5 from "../assets/images/item3/subitm5.jpg";
import img6 from "../assets/images/item3/subitm6.jpg";
import img8 from "../assets/images/item3/subitm8.jpg";
import img9 from "../assets/images/item3/subitm9.jpg";
import img10 from "../assets/images/item3/subitm10.jpg";

const rowsData = [
  {
    id: 1,
    title: "Electrical Control Panel",
    text: "Reliable electrical control panels for safe power distribution and system management.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Electrical control panels manage and distribute power across industrial and commercial setups. They house circuit breakers, switches, and control devices for smooth operations. Built with high-quality materials to ensure durability and safety.
`
  },
  {
    id: 2,
    title: "Electrical Fuses",
    text: "High-quality electrical fuses for reliable circuit protection and safety.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Electrical fuses protect circuits by preventing damage from overloads and short circuits. They are designed to break the circuit when excessive current flows. Available in various types and ratings to suit industrial and residential needs.
`
  },
  {
    id: 3,
    title: "Breaker Box",
    text: "Sturdy breaker boxes for safe and organized electrical power distribution.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Breaker boxes house circuit breakers that protect electrical systems from overloads and short circuits. They distribute electricity safely to various parts of a building or industrial setup. Built with high-quality materials to ensure durability and fire safety.
`
  },
  {
    id: 4,
    title: "Electrical Terminal Block",
    text: "Durable terminal blocks for secure and efficient electrical connections.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Electrical terminal blocks provide a safe way to connect multiple wires in a circuit. They simplify wiring and ensure stable electrical connections. Made from high-quality materials for long-lasting performance and safety.
`
  },
  {
    id: 5,
    title: "Proximity Sensors",
    text: "High-precision proximity sensors for accurate object detection without physical contact.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Proximity sensors detect the presence or absence of objects without touching them. They are widely used in industrial automation, robotics, and safety systems. Available in various types such as inductive, capacitive, and photoelectric.
`
  },
  {
    id: 6,
    title: "All Types of Electrical Wires",
    text: "Quality electrical wires for safe and efficient power transmission.",
    img: img6,
    gradient: "gradient1",
    stars: 4,
    description: `We offer a wide range of electrical wires for residential, commercial, and industrial use. Designed to handle different voltage levels and environmental conditions. Made with high-quality copper or aluminum for excellent conductivity.
`
  },
  {
    id: 7,
    title: "Plugs and Sockets",
    text: "Reliable plugs and sockets for safe and convenient electrical connections.",
    img: img8,
    gradient: "gradient3",
    stars: 3,
    description: `Plugs and sockets provide secure connections for electrical appliances and systems. Available in various types and sizes to suit different applications. Manufactured with high-quality materials for safety and durability.
`
  },
  {
    id: 8,
    title: "Contractor",
    text: "Heavy-duty contactors for reliable control of electrical circuits and machinery.",
    img: img9,
    gradient: "gradient4",
    stars: 4,
    description: `Contactors are electrical switches used to control high-voltage circuits and motors.
They provide safe and efficient switching for industrial and commercial equipment.
Built to handle heavy electrical loads with long operational life.
`
  },
  {
    id: 9,
    title: "Circuit Breaker",
    text: "High-quality circuit breakers for reliable protection against overloads and short circuits.",
    img: img10,
    gradient: "gradient5",
    stars: 5,
    description: `Circuit breakers automatically cut off power during overloads or faults to prevent damage. They protect electrical equipment and reduce the risk of fire or electrical hazards. Available in various types like MCB, MCCB, and RCCB for different applications.
`
  }
];

function Z3() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z3;